import { useState, useEffect } from "react";
import api from "../api/axios";

/**
 * Hook pour récupérer les modules d'une page selon le slug frontend
 * @param {string} slug - slug depuis l'URL frontend
 */
export default function usePageModules(slug) {
    const [page, setPage] = useState(null);
    const [modules, setModules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let mounted = true;

        if (!slug) return;

        const fetchPageAndModules = async () => {
            setLoading(true);
            setError(null);

            try {
                const pageRes = await api.get(`/api/web-pages/${slug}`);
                const pageData = pageRes.data;
                if (!pageData) throw new Error(`Page introuvable pour le slug "${slug}"`);

                if (mounted) setPage(pageData);

                const modulesRes = await api.get(`/api/modules`);
                let pageModules = modulesRes.data || [];

                pageModules = pageModules.filter(
                    (mod) => mod.web_page.id === pageData.id
                );

                if (mounted) setModules(pageModules);
            } catch (err) {
                console.error(err);
                if (mounted) setError(err);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        fetchPageAndModules();

        return () => {
            mounted = false;
        };
    }, [slug]);

    return { page, modules, loading, error };
}
